import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { AccountService } from 'app/model/services/api-services/account.service';
export type OrgInfoViewNames = 'projects' | 'metadata' | 'employees' | 'crews' | 'templates';

@Component({
  selector: 'app-org-info',
  templateUrl: './org-info.component.html',
  styleUrls: ['./org-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgInfoComponent implements AfterViewInit {

  constructor(private cdr: ChangeDetectorRef, private activatedRoute: ActivatedRoute, private accountSvc: AccountService) { }

  public currentView: OrgInfoViewNames = 'projects';
  public get viewTitle(): string {
    switch (this.currentView) {
      case 'projects':
        return 'Projects';
      case 'crews':
        return 'Crews';
      case 'employees':
        return 'employees';
      case 'metadata':
        return 'Org Info';
      case 'templates':
        return 'Templates';
    }
    return '';
  }
  public orgId: number = -1;
  private _ready: boolean = false;
  public orgInfoReady:boolean = false;
  ngAfterViewInit(): void {
    this._ready = true;
    const param = this.activatedRoute.snapshot.paramMap.get('organization_id');
    this.orgId = !!param ? Number(param) : -2;
    this.accountSvc.GetAccount(this.orgId).then((response) => {
      this.orgInfoReady = true;
      this.Refresh();
    });
  }
  SetView(viewName: OrgInfoViewNames) {
    this.currentView = viewName;
    this.Refresh();
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
}
